import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SideNavbarComponent } from './side-navbar/side-navbar.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { MainShellComponent } from './main-shell/main-shell.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ChatComponent } from './chat/chat.component';
import { MaterialModule } from '../../../shared/modules/material.module';
import { CreateModalComponent } from './create-modal/create-modal.component';

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    MainShellComponent,
    SideNavbarComponent,
    ChatComponent,
    CreateModalComponent
  ],
  exports: [
    SidebarComponent,
    HeaderComponent,
    FooterComponent,
    SideNavbarComponent,
    ChatComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    MaterialModule
  ]
})
export class FragmentsModule { }
